/* eslint-disable no-empty */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

// Fetch all custom codes (GET)
export const getAllCustomCodes = createAsyncThunk('get All custom codes', async () => {
  let response = [null, null];
  try {
    const res = await $axios.get('/code');
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response || "Something went wrong"];
  } finally {
    return response;
  }
});

// Fetch a single custom code by type (GET)
export const getCustomCodeByType = createAsyncThunk('get Single custom code', async (type) => {
  let response = [null, null];
  try {
    const res = await $axios.get(`/code?type=${type}`);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response?.data?.message || err?.response || "Something went wrong"];
  } finally {
    // console.log(response);
    return response;
  }
});

// Fetch custom codes (GET)
export const getCustomCodes = createAsyncThunk('get custom codes', async (type) => {
  let response = [null, null];
  try {
    const res = await $axios.get(`/code`);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response?.data?.message || err?.response || "Something went wrong"];
  } finally {
    console.log(response);
    return response;
  }
});

// Create a new custom code (POST)
export const createCustomCode = createAsyncThunk('create Custom code', async (obj) => {
  let response = [null, null];
  try {
    const res = await $axios.post('/code', obj);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response?.data?.message || err?.response || "Something went wrong"];
  } finally {
    // console.log(response);
    return response;
  }
});

// Update an existing custom code (PUT)
export const updateCustomCode = createAsyncThunk('update Custom code', async ({ id, code }) => {
  let response = [null, null];
  try {
    const res = await $axios.put(`/code/${id}`, { code });
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response?.data?.message || err?.response || "Something went wrong"];
  } finally {
    return response;
  }
});

// Delete a custom code (DELETE)
export const deleteCustomCode = createAsyncThunk('delete Custom code', async (id) => {
  let response = [null, null];
  try {
    const res = await $axios.delete(`/code/${id}`);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response || "Something went wrong"];
  } finally {
    return response;
  }
});

export const resetCustomCodeState = createAsyncThunk('reset all custom code state', async (id) => {
  return 'reset all custom code state';
});

// Slice
const customCodeSlice = createSlice({
  name: 'customCodeSlice',
  initialState: {
    allCustomCodes: null,
    singleCustomCode: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Fetch all
    builder
      .addCase(getAllCustomCodes.pending, (state) => {
        state.allCustomCodes = null;
      })
      .addCase(getAllCustomCodes.fulfilled, (state, action) => {
        state.allCustomCodes = action.payload;
      });

    builder
      .addCase(getCustomCodes.pending, (state) => {
        state.allCustomCodes = null;
      })
      .addCase(getCustomCodes.fulfilled, (state, action) => {
        state.allCustomCodes = action.payload;
      });

    // Fetch single
    builder
      .addCase(getCustomCodeByType.pending, (state) => {
        state.singleCustomCode = null;
      })
      .addCase(getCustomCodeByType.fulfilled, (state, action) => {
        state.singleCustomCode = action.payload;
      });

    // Create
    builder
      .addCase(createCustomCode.pending, (state, action) => {
        state.singleCustomCode = null;
      })
      .addCase(createCustomCode.fulfilled, (state, action) => {
        state.singleCustomCode = action.payload;
      });

    // Update
    builder
      .addCase(updateCustomCode.fulfilled, (state, action) => {
        if (state.allCustomCodes) {
          state.allCustomCodes = state.allCustomCodes.map((item) =>
            String(item._id) === String(action.payload._id) ? action.payload : item
          );
        }
      });

    // Delete
    builder
      .addCase(deleteCustomCode.fulfilled, (state, action) => {
        if (state.allCustomCodes) {
          state.allCustomCodes = state.allCustomCodes.filter(
            (item) => item._id !== action.payload._id
          );
        }
      });

    // Reset
    builder
      .addCase(resetCustomCodeState.fulfilled, (state, action) => {
        state.allCustomCodes = null;
        state.singleCustomCode = null;
      });
  },
});

export default customCodeSlice.reducer;
